import type { Location } from '@cobliteam/common-types';

import { history } from '../history';

/**
 * @deprecated The method should not be used anymore. Use useHistory from react-router-dom instead.
 */
export const locationChange = (location: Location, search?: string, state?: object) =>
  history.push({
    pathname: location,
    search,
    state,
  });
